<template>
  <MultipleChoicesDropdown
    title="Intellectual Property Rights"
    :value="startup.intellectual_property"
    :show-clear-all="false"
    :single-choice="true"
    :search-enabled="false"
    :choices="getIntellectualProperty()"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'
import getIntellectualProperty from '@/services/intellectual-property-rights'

export default {
  computed: {
    ...mapState({
      startup: (state) => state.startupProfile.startup,
    }),
  },
  methods: {
    onChange(choice) {
      const attr = 'intellectual_property'
      const value = choice.value
      this.$store.commit('startupProfile/SET_STARTUP_ATTR', { attr, value })
    },
    getIntellectualProperty,
  },
}
</script>
